import { render, staticRenderFns } from "./AppendixQR.vue?vue&type=template&id=2d70cbb6&scoped=true"
import script from "./AppendixQR.vue?vue&type=script&lang=js"
export * from "./AppendixQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d70cbb6",
  null
  
)

export default component.exports